import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const tableTruncateFn = /* @__PURE__ */ createRecipe('table-truncate', {}, [])

const tableTruncateVariantMap = {
  "mode": [
    "end",
    "start",
    "middle",
    "none"
  ]
}

const tableTruncateVariantKeys = Object.keys(tableTruncateVariantMap)

export const tableTruncate = /* @__PURE__ */ Object.assign(memo(tableTruncateFn.recipeFn), {
  __recipe__: true,
  __name__: 'tableTruncate',
  __getCompoundVariantCss__: tableTruncateFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: tableTruncateVariantKeys,
  variantMap: tableTruncateVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, tableTruncateVariantKeys)
  },
  getVariantProps: tableTruncateFn.getVariantProps,
})